import React from 'react';

import { DatePicker, ExportModal } from '../../uiold';
import { Button, Stack } from '../../../core-ui';
import FormSection from '../../VendorList/FormSection';
import { SelectedDateRange } from '../VendorBillingExportDialog';

type Props = {
  dateRange: SelectedDateRange;
  isLoading: boolean;
  onDismiss: () => void;
  onSubmit: () => void;
  setDateRange: (dateRange: SelectedDateRange) => void;
};

export function ExportVendorSalesModal(props: Props) {
  const { dateRange, isLoading, onDismiss, onSubmit, setDateRange } = props;
  return (
    <ExportModal
      title={t('Export Vendor Sales')}
      isLoading={isLoading}
      onSubmit={onSubmit}
      onClose={() => {
        onDismiss();
      }}
    >
      <FormSection
        title={t('Date Range')}
        subtitle={t(
          'Include only vendors with vendor sales in selected date range',
        )}
      >
        <DatePicker
          selectedDates={new Set(dateRange)}
          onDateClick={(date) => {
            setDateRange(
              dateRange.length === 1 ? [...dateRange, date] : [date],
            );
          }}
          isDateRange
        />
        {dateRange.length === 2 && (
          <Stack direction="row" spacing={4} justify="center">
            <Button variant="link" onClick={() => setDateRange([])}>
              {t('Clear Dates')}
            </Button>
          </Stack>
        )}
      </FormSection>
    </ExportModal>
  );
}
